import { render, staticRenderFns } from "./CourseSetting.vue?vue&type=template&id=95f70f62"
import script from "./CourseSetting.vue?vue&type=script&lang=ts"
export * from "./CourseSetting.vue?vue&type=script&lang=ts"
import style0 from "./CourseSetting.vue?vue&type=style&index=0&id=95f70f62&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports